// polyfills
// import 'core-js/fn/array/from';
//import './modules/polyfills';

// detect mobile devices
// import './modules/mobileDetect';

// external svg support for old browsers
// import 'svgxuse';

// jQuery
//import jQuery from 'jquery';

// modules
import { svgLoad } from './modules/svg';
//import { lazyLoad } from "./modules/lazyload";
import {popups} from "./modules/popups";
import {menu} from "./modules/menu";
import {carousel} from "./modules/carousel";
import {hidden} from "./modules/hidden";
import {scrollTo} from "./modules/scrollTo";
import {fixedHeader} from "./modules/fixedHeader";
import {table} from "./modules/table";
import {counter} from "./modules/counter";
import {forms} from "./modules/forms";

//window.$ = window.jQuery = jQuery;

//window.overlay = overlay;
//window.popup = popup;
//window.authorization = new Auth();

window.initModules = () => {
    svgLoad();
    //lazyLoad();
    carousel();
    hidden();
    table();
    fixedHeader();
    popups();
    menu();
    scrollTo();
    counter();
    forms();
};

if (document.readyState === 'complete') {
    initModules();
} else if (document.readyState === 'interactive') {
    initModules();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        initModules();
    });
}
